module.exports = {
	'auth/user-not-found': 'Não existe um registro de usuário correspondente a este email. O usuário pode ter sido removido.',
	'auth/wrong-password': 'A senha informada está incorreta.',
	'auth/invalid-email': 'O email informado não é válido.'
}


// WEBPACK FOOTER //
// ./src/helpers/Messages/index.js